// API helpers for the Load Truck Simulator wizard.
// Talks to eng-backend (port 5000) — the same host as the warehouse routes.

import axios from 'axios';
import { API } from '../../config/api';

const http = axios.create({
  baseURL: API.BACKEND,
  timeout: 15000,
});

http.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['x-auth-token'] = token;
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// GET /api/v1/standard — returns the full catalog used by the cable picker.
export async function fetchAllStandards() {
  const { data } = await http.get('/api/v1/standard');
  // Controller returns either { data: [...] } or a raw array depending on
  // the advancedResults wrapper; tolerate both so we don't care which.
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.standards)) return data.standards;
  return [];
}

// POST /api/v1/simulation/products — given one cable descriptor + length,
// returns the total weight (copper + insulation + sheathing layers summed).
//
// Input cable shape (must match standard identity exactly):
//   { cableName, numberOfConductors, section, color,
//     length, hasMixedConductorSections?, greenYellowSection? }
//
// Returns { totalWeightKg, copperKg, layersKg, raw } — or throws on mismatch.
export async function fetchCableWeight(cable) {
  const { data } = await http.post('/api/v1/simulation/products', {
    cables: [cable],
  });

  const row = Array.isArray(data?.result) ? data.result[0] : null;
  if (!row || row.error) {
    const reason = row?.error || data?.missing?.[0]?.reason || 'No matching standard';
    throw new Error(reason);
  }

  const copperKg = Number(row.copperWeightTotalKg || 0);
  const layersKg = Array.isArray(row.layers)
    ? row.layers.reduce((a, l) => a + Number(l.quantityTotal || 0), 0)
    : 0;

  return {
    totalWeightKg: copperKg + layersKg,
    copperKg,
    layersKg,
    raw: row,
  };
}
